import React from 'react';

import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';

const TypeLink = ({ to, children }) => {
  const currentUrl = window.location.pathname;

  return currentUrl === '/enviar-indicadores-gerais' ||
    currentUrl.includes('formulario-linha-de-cuidado') ||
    currentUrl.includes('formulario-linhas-de-cuidado') ? (
    <a href={to}>{children}</a>
  ) : (
    <Link to={to}>{children}</Link>
  );
};

TypeLink.propTypes = {
  to: PropTypes.string,
  children: PropTypes.node.isRequired,
};

TypeLink.defaultProps = {
  to: '',
};

export default TypeLink;
